import React from "react";
import { Box } from "@mui/material";
const footer = () => {
  return (
    <Box sx={{ backgroundColor: "#212121", color: "white" }}>
      <footer>
        <i className="fab fa-github">&nbsp;&nbsp;&nbsp; </i>
        <i className="fab fa-twitter">&nbsp;&nbsp;&nbsp; </i>
        <i className="fab fa-discord">&nbsp;&nbsp;&nbsp;</i>
        <i className="fab fa-linkedin-in">&nbsp;&nbsp;&nbsp;</i>
        <i className="fab fa-youtube">&nbsp;&nbsp;&nbsp;</i>
      </footer>
    </Box>
  );
};

export default footer;
